import { NgModule } from '@angular/core';
import { TimeUtils } from './time-utils.service';

@NgModule({
  imports: [],
  providers: [TimeUtils],
})
export class TimeUtilsModule {}
